/* Increase comments to 1000 characters Feb 225, 20225 */
<template lang="pug">
	div(class="kt-debrief")
		div(class="debr-header")
			div(class="debr-date")
				span Debrief Date
				div
					b-form-select(:options="c_selDebrDates" v-model="d_debrIdCurr" plain @change="m_chgDebr")
			div(class="small")
				b-button(class="btn-refresh" title="Refresh" variant="outline-secondary" @click="m_refreshClick")
					fa-icon(icon="sync")
		div(class="debr-content")
			//- Loading
			kt-spinner(v-if="d_loading" p_txt="Debrief")
			table(v-show="!d_loading")
				thead
					th Debrief Question
					th(class="score") Score
					th(class="cmnt") Comments
				tbody
					tr(v-for="(s,ix) in d_scores" :key="ix" class="qstn")
						td {{m_questTxt(s.debriefQuestionId)}}
						td
							b-form-select(:options="c_selScores" v-model="s.score" plain)
						td
							b-form-input(type="text" v-model="s.comments" maxlength=1000)
				tfoot
					tr(class="score")
						td(colspan=2)
							div(class="font-weight-bold")
								span Total score:
								span {{d_debr.totalScore}}
						td(rowspan=4)
							b-form-textarea(v-model="d_debr.comments" rows=3 maxlength=1000  placeholder='Additional Debrief Comments')
					tr(class="max-score")
						td(colspan=2)
							div
								span Max score:
								span {{c_maxScore}}
					tr(class="pct")
						td(colspan=2) 
							div
								span % of Max score:
								span  {{c_pctOfMax}}%
					tr
						td(colspan=2) 
		div(class="debr-footer" v-show="!d_loading")
			div
				b-button(class="btn-save" title="Save" variant="primary" @click="m_save") Save
			div(v-if="d_debrIdCurr!='new'" class="info")
				span Created on {{d_util.fn_fmtDtmStr(d_debr.createdUTC,true)}} by {{d_debr.createdBy}}
				span(v-if="d_debr.updatedUTC") Last updated on {{d_util.fn_fmtDtmStr(d_debr.updatedUTC,true)}} by {{d_debr.updatedBy}}

</template>

<script>

import {fn_getDebriefs, fn_saveDebrief, fn_getProjectDebriefs, fn_saveProjectDebrief} from "@/utils/api.js";
import util, {kbdpAlert} from "@/utils/util.js";
import {refData} from "@/utils/ref-data.js";

export default {
	name: "kt-debrief",
	components: {},
	created() {
		fn_getData(this);
	},
	data() {
		return {
			d_util: util,
			d_resp: {
				debriefs: [],
				debriefScores: [],
			},

			d_debr: fn_debr(),
			d_scores: fn_debrScores(),
			d_debrIdCurr: 'new',
			d_loading: null,
		};
	},
	props: {
		p_recInfo: Object,
	},
	computed: {
		c_selDebrDates() {
			let d = this.d_resp.debriefs.map(d => ({
				value: d.debriefId,
				text: util.fn_fmtDtmStr(d.createdUTC, true),
			}));
			return [...d, {value: 'new', text: 'Create New'}];
		},
		c_selScores() {
			let s = [];
			for (let i = 1; i <= 10; i++) {
				s.push({text: i, value: i});
			}
			return s;
		},
		c_totalScore() {
			let d = this.d_scores.map(x => x.score);
			return Math.round(util.fn_calcSum(d, false) * 1000) / 1000;
		},
		c_maxScore() {
			let d = this.d_scores.map(x => 10);
			return util.fn_calcSum(d, false);
		},
		c_pctOfMax() {
			return Math.round(this.c_totalScore * 1000 / this.c_maxScore) / 10;
		},
	},
	methods: {
		m_questTxt(questId) {
			return refData.debriefQuestions.filter(x => x.id == questId)[0].quest;
		},
		m_save() {
			fn_saveData(this);
		},
		m_refreshClick() {
			fn_getData(this);
		},
		m_chgDebr() {
			fn_setDebriefData(this);
		}
	},
	watch: {
		c_totalScore(nv) {
			this.d_debr.totalScore = nv;
		}
	}

};

function fn_debr() {
	return {
		debriefId: null,
		totalScore: null,
		comments: null,
		createdUTC: null,
		createdBy: null,
		updatedUTC: null,
		updatedBy: null,
	};
}

function fn_debrScores() {
	let dq = refData.debriefQuestions.filter(x => !x.disabled);

	return dq.map(q => ({
		debriefScoreId: null,
		debriefQuestionId: q.id,
		score: null,
		comments: null,
	}));
}

function fn_getData(vc) {
	vc.d_loading = true;
    if(vc.p_recInfo.Type=='project'){
	fn_getProjectDebriefs(vc.p_recInfo.Id).then(resp => {
		vc.d_loading = null;
		if (resp.error || resp.errorMessage) {
			let msg = `Unable to load Debrief ` + (resp.error || "");
			kbdpAlert.showErr(msg);
			return;
		}
		else {
			kbdpAlert.clear();
		}

		let debr = resp.debriefs;
		let debrScr = resp.debriefScores;

		vc.d_resp.debriefs = debr || [];
		vc.d_resp.debriefscores = debrScr || [];

		if (!debr) return;

		vc.d_debrIdCurr = debr[0].debriefId;
		fn_setDebriefData(vc);
	});
	}
	else{
	fn_getDebriefs(vc.p_recInfo.Id).then(resp => {
		vc.d_loading = null;
		if (resp.error || resp.errorMessage) {
			let msg = `Unable to load Debrief ` + (resp.error || "");
			kbdpAlert.showErr(msg);
			return;
		}
		else {
			kbdpAlert.clear();
		}

		let debr = resp.debriefs;
		let debrScr = resp.debriefScores;

		vc.d_resp.debriefs = debr || [];
		vc.d_resp.debriefscores = debrScr || [];

		if (!debr) return;

		vc.d_debrIdCurr = debr[0].debriefId;
		fn_setDebriefData(vc);
	});
	}
}

function fn_saveData(vc) {
	kbdpAlert.showSaving('Debrief');
	let debrData = {
		debrief: vc.d_debr,
		debriefScores: vc.d_scores,
	};
	
    if(vc.p_recInfo.Type=='project'){
	fn_saveProjectDebrief(vc.p_recInfo.Id, debrData).then(resp => {
		if (resp.error || !resp.upsRecHdr) {
			let msg = `Unable to save Debrief ` + (resp.error || "");
			kbdpAlert.showErr(msg);
			return;
		}
		else {
			kbdpAlert.clear();
		}
		let debr = resp.upsRecHdr.debrief;
		let debrScr = resp.upsRecHdr.debriefScores;
		Object.keys(debr).forEach(k => {
			vc.d_debr[k] = debr[k];
		});
		
		util.fn_spliceById(vc.d_resp.debriefs, 'debriefId', vc.d_debr.debriefId, vc.d_debr);

		debrScr.forEach(ds => {
			let vcds = vc.d_scores.filter(x => x.debriefQuestionId == ds.debriefQuestionId)[0];
			if (vcds) {
				vcds.debriefScoreId = ds.debriefScoreId;
				util.fn_spliceById(vc.d_resp.debriefscores, 'debriefScoreId', ds.debriefScoreId, vcds);
			}
		});

		
		});
		
		}else {
		fn_saveDebrief(vc.p_recInfo.Id, debrData).then(resp => {
		if (resp.error || !resp.upsRecHdr) {
			let msg = `Unable to save Debrief ` + (resp.error || "");
			kbdpAlert.showErr(msg);
			return;
		}
		else {
			kbdpAlert.clear();
		}
		let debr = resp.upsRecHdr.debrief;
		let debrScr = resp.upsRecHdr.debriefScores;

		Object.keys(debr).forEach(k => {
			vc.d_debr[k] = debr[k];
		});
		
		util.fn_spliceById(vc.d_resp.debriefs, 'debriefId', vc.d_debr.debriefId, vc.d_debr);

		debrScr.forEach(ds => {
			let vcds = vc.d_scores.filter(x => x.debriefQuestionId == ds.debriefQuestionId)[0];
			if (vcds) {
				vcds.debriefScoreId = ds.debriefScoreId;
				util.fn_spliceById(vc.d_resp.debriefscores, 'debriefScoreId', ds.debriefScoreId, vcds);
			}
		});

		
		});
		
		}
			
		
		kbdpAlert.showOk('The Debrief was saved successfully');
	
}


function fn_setDebriefData(vc) {
	let debrId = vc.d_debrIdCurr;

	if (debrId == 'new') {
		vc.d_debr = fn_debr();
		vc.d_scores = fn_debrScores();
		return;
	}
	else {
		vc.d_scores.length = 0;
	}

	let debr = vc.d_resp.debriefs.filter(d => d.debriefId == debrId)[0];
	Object.keys(vc.d_debr).forEach(k => {
		let dVal = debr[k];
		if (dVal == null || dVal == undefined) return;
		vc.d_debr[k] = dVal;
	});

	vc.d_resp.debriefscores.filter(ds => ds.debriefId == debrId).forEach(ds => {
		vc.d_scores.push(ds);
	});
}



</script>

<style lang="less">
div.kt-debrief {
	div.debr-header {
		display: flex;
		padding: 0.4em 0;
		margin-bottom: 0.2em;
		// border-bottom: solid 0.1em #adb5bd;

		div.debr-date {
			font-size: 0.9em;
			display: flex;
			flex-grow: 1;

			> span:first-child {
				padding-right: 0.5em;
			}
			> div {
				padding-right: 0.5em;
				select {
					font-size: 0.9em;
					padding: 0.2em 0em;
					width: 175px;
				}
			}
		}

		.btn-refresh {
			font-size: 1em;
			margin-right: 0.3em;
			padding: 0em 0.3em;
		}
	}
	div.debr-content {
		overflow-x: auto;
		table {
			font-size: 0.9em;
			text-align: left;
			width: 100%;
			min-width: 500px;
			thead th {
				border-bottom: solid 0.2em #adb5bd;
				&.score {
					width: 90px;
				}
				&.cmnt {
					width: 40%;
				}
			}
			tbody {
				tr {
					border-bottom: solid 0.1em #adb5bd;
					&:hover {
						background-color: #f8f9fa;
					}
				}
				tr td {
					padding: 0.4em 0.2em;
					> select {
						font-size: 0.95em;
						max-width: 55px;
						height: 25px;
					}
					> input[type="text"] {
						font-size: 0.95em;
					}
				}
			}
			tfoot {
				border-bottom: solid 0.2em #adb5bd;
				tr td {
					padding: 0.2em 0;
				}
				tr > td > div {
					// border: solid 0.1em red;
					padding-right: 2em;
					display: inline-block;
					min-width: 200px;
					> span:first-child {
						padding-right: 0.5em;
					}
					> span:last-child {
						display: inline-block;
						text-align: left;
						width: 55px;
					}
				}
				tr.score,
				tr.max-score,
				tr.pct {
					height: 20px;
					td:first-child {
						text-align: right;
					}
				}
				tr td textarea {
					font-size: 0.95em;
					margin: 0.5em 0;
					resize: vertical;
					min-height: 100px;
					max-height: 400px;
				}
			}
		}
	}
	div.debr-footer {
		padding-top: 0.5em;
		display: flex;

		> div:first-child {
			text-align: left;
			.btn-save {
				padding: 0.1em 0.4em;
			}
		}
		div.info {
			padding: 0 0.5em;
			margin: auto 0;
			font-size: 0.8em;
			flex-grow: 1;
			> span {
				display: block;
			}
		}
	}
}
</style>